(() => {
  'use strict';
  const node = document.querySelector('[data-kalie-cro-config]');
  if (!node) return;
  const cfg = JSON.parse(node.textContent), text = cfg.text;
  const root = window.Shopify?.routes?.root || window.KALIE_CONFIG?.root || '/';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const storage = { get(key) { try { return sessionStorage.getItem(key) || ''; } catch { return ''; } }, set(key, value) { try { value ? sessionStorage.setItem(key, value) : sessionStorage.removeItem(key); } catch {} } };
  const format = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`__${k}__`, String(v)), text[key] || key);
  const money = (amount, currency = 'EUR') => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(amount / 100);
  const $ = (selector, scope = document) => scope.querySelector(selector);
  let appliedCode = storage.get('kalie_applied_code'), cart = null, promoBusy = false;
  const canonical = code => String(code || '').trim().toUpperCase();
  const checkoutUrl = () => root + 'checkout' + (appliedCode ? '?discount=' + encodeURIComponent(appliedCode) : '');
  window.KALIE_PROMO = Object.freeze({ checkoutUrl, reconcile(data) { if (data) cart = data; if (cart) renderPromo(cart); } });

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-kalie-copy-code]');
    if (button) {
      if (button.disabled) return;
      let copied = false;
      try { await navigator.clipboard.writeText('BIENVENUE15'); copied = true; } catch {
        const field = document.createElement('textarea');
        field.value = 'BIENVENUE15'; field.setAttribute('readonly', ''); field.className = 'kalie-cro-sr-only';
        document.body.append(field); field.select();
        try { copied = document.execCommand('copy'); } catch {}
        field.remove(); button.focus({ preventScroll: true });
      }
      if (copied) {
        storage.set('kalie_promo_code', 'BIENVENUE15');
        const input = $('[data-kalie-promo-input]');
        if (input && !input.value) input.value = 'BIENVENUE15';
        button.textContent = button.dataset.copiedLabel;
      } else button.textContent = button.dataset.errorLabel;
      button.disabled = true;
      setTimeout(() => { button.textContent = button.dataset.copyLabel; button.disabled = false; }, 3000);
    }
    const review = event.target.closest('[data-kalie-review-link]');
    if (review) {
      const target = document.getElementById('avis-clients');
      if (target) { event.preventDefault(); target.scrollIntoView({ behavior: reduce.matches ? 'instant' : 'smooth', block: 'start' }); target.focus({ preventScroll: true }); }
    }
  });

  const parisParts = date => Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(date).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  const dayStamp = parts => new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  function zonedCutoff(day, hour) {
    const desired = Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), hour);
    let instant = desired;
    for (let i = 0; i < 3; i++) {
      const p = parisParts(new Date(instant));
      instant += desired - Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    }
    return instant;
  }
  function addDays(day, count) {
    const result = new Date(day);
    for (let added = 0; added < count;) { result.setUTCDate(result.getUTCDate() + 1); if (result.getUTCDay() !== 0) added++; }
    return result;
  }
  const dateFormat = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
  function delivery() {
    const now = new Date(), parts = parisParts(now), today = dayStamp(parts);
    let primaryEstimate = '';
    document.querySelectorAll('[data-kalie-delivery]').forEach((block, index) => {
      const hour = Number(block.dataset.cutoff || 16), cutoffDay = new Date(today);
      if (parts.hour >= hour || cutoffDay.getUTCDay() === 0) {
        do { cutoffDay.setUTCDate(cutoffDay.getUTCDate() + 1); } while (cutoffDay.getUTCDay() === 0);
      }
      const remaining = Math.max(1, Math.ceil((zonedCutoff(cutoffDay, hour) - now.getTime()) / 60000));
      $('[data-kalie-cutoff]', block).textContent = format('countdown', { HOURS: Math.floor(remaining / 60), MINUTES: remaining % 60 });
      const min = Math.max(1, Number(block.dataset.minDays || 2)), max = Math.max(min, Number(block.dataset.maxDays || 4));
      const estimate = format('delivery', { MIN: dateFormat.format(addDays(cutoffDay, min)), MAX: dateFormat.format(addDays(cutoffDay, max)) });
      $('[data-kalie-eta]', block).textContent = estimate;
      if (index === 0) primaryEstimate = estimate;
    });
    if (primaryEstimate) document.querySelectorAll('#cart-dialog [data-kc-eta]').forEach(el => {
      const label = $('span', el);
      if (label) label.textContent = primaryEstimate;
    });
  }
  function variantState(product, finish, available, pack) {
    const stock = $('[data-kalie-stock]', product);
    if (stock) {
      stock.toggleAttribute('data-unavailable', !available);
      $('[data-kalie-stock-text]', stock).textContent = format(available ? 'stock' : 'sold', { FINISH: finish });
      $('[data-kalie-shipping-content]', product).hidden = !available;
    }
    product.querySelectorAll('[data-kalie-annual-gift]').forEach(el => { el.hidden = pack !== '12-mois' || product.dataset.kalieBonusEnabled !== 'true'; });
  }
  document.addEventListener('kalie:selection', event => {
    const { product, finish, available, pack } = event.detail;
    variantState(product, finish, available, pack);
  });

  function codeSavings(data, code) {
    let sum = 0;
    for (const discount of data.cart_level_discount_applications || []) {
      if (discount.type === 'discount_code' && canonical(discount.title) === code) sum += Number(discount.total_allocated_amount || 0);
    }
    for (const item of data.items || []) for (const allocation of item.line_level_discount_allocations || []) {
      const discount = allocation.discount_application;
      if (discount?.type === 'discount_code' && canonical(discount.title) === code) sum += Number(allocation.amount || 0);
    }
    return sum;
  }
  function renderPromo(data) {
    cart = data;
    delivery();
    const drawer = $('#cart-dialog'), status = $('[data-kalie-promo-status]', drawer);
    if (!drawer || !status) return;
    const input = $('[data-kalie-promo-input]', drawer), remove = $('[data-kalie-promo-remove]', drawer);
    const row = $('[data-kalie-promo-row]', drawer), note = $('[data-kalie-preview-note]', drawer);
    const totalLabel = $('[data-kalie-total-label]', drawer), hasItems = data.item_count > 0;
    $('#cart-total', drawer).textContent = money(data.total_price, data.currency);
    $('[data-kc-btn-total]', drawer).textContent = hasItems ? money(data.total_price, data.currency) : '';
    let code = canonical(appliedCode);
    const accepted = (data.discount_codes || []).find(x => x.applicable && canonical(x.code) === code);
    const actual = code ? codeSavings(data, code) : 0;
    row.hidden = true; note.hidden = true;
    totalLabel.textContent = text.total;
    remove.hidden = !code;
    if (!input.value && document.activeElement !== input) input.value = code || storage.get('kalie_promo_code');
    if (!code) { if (!promoBusy) status.textContent = ''; return; }
    if (actual > 0 || accepted) {
      status.textContent = format('applied', { CODE: code });
      if (actual > 0) {
        row.hidden = false;
        $('[data-kalie-promo-label]', row).textContent = code === 'BIENVENUE15' ? format('discountLabel', { CODE: code }) : code;
        $('[data-kalie-promo-saving]', row).textContent = '−' + money(actual, data.currency);
        const original = data.original_total_price || data.total_price;
        const otherDiscount = Math.max(0, original - data.total_price - actual);
        $('[data-kc-save-row]', drawer).hidden = otherDiscount === 0;
        $('[data-kc-save]', drawer).textContent = '−' + money(otherDiscount, data.currency);
      }
    } else if (code === 'BIENVENUE15' && !cfg.returningCustomer && hasItems) {
      const original = Number(data.original_total_price || data.total_price);
      const welcomeTotal = Math.round(original * .85), preview = Math.max(0, Number(data.total_price) - welcomeTotal);
      status.textContent = text.eligibility;
      note.hidden = false;
      note.textContent = preview > 0 ? text.previewNote : text.bestOffer;
      if (preview > 0) {
        row.hidden = false;
        $('[data-kalie-promo-label]', row).textContent = text.previewLabel;
        $('[data-kalie-promo-saving]', row).textContent = '−' + money(preview, data.currency);
        totalLabel.textContent = text.estimatedTotal;
        $('#cart-total', drawer).textContent = money(welcomeTotal, data.currency);
        $('[data-kc-btn-total]', drawer).textContent = '≈ ' + money(welcomeTotal, data.currency);
      }
    } else if (hasItems) status.textContent = text.ineligible;
  }
  async function updateCode(code) {
    const response = await fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) });
    const data = await response.json();
    if (!response.ok || !Array.isArray(data.items)) throw new Error(data.description || text.promoError);
    return data;
  }
  async function applyCode(code) {
    const form = $('[data-kalie-promo-form]'), status = $('[data-kalie-promo-status]');
    if (promoBusy || !form) return;
    const input = $('[data-kalie-promo-input]'), normalized = canonical(code);
    if (normalized && !/^[\p{L}\p{N}_-]{1,100}$/u.test(normalized)) { status.textContent = text.invalid; return; }
    if (normalized === 'BIENVENUE15' && cfg.returningCustomer) { status.textContent = text.ineligible; return; }
    if (!cart?.item_count) { status.textContent = text.emptyCart; return; }
    promoBusy = true;
    const button = $('[data-kalie-promo-apply]'); button.disabled = true;
    $('[data-kalie-promo-remove]').disabled = true;
    status.textContent = text.applying;
    form.setAttribute('aria-busy', 'true');
    try {
      const preserved = (cart.discount_codes || []).filter(d => d.applicable && canonical(d.code) !== canonical(appliedCode)).map(d => d.code);
      const data = await updateCode([...new Set([...preserved, ...(normalized ? [normalized] : [])])].join(','));
      const accepted = (data.discount_codes || []).some(d => d.applicable && canonical(d.code) === normalized) || codeSavings(data, normalized) > 0;
      if (normalized && normalized !== 'BIENVENUE15' && !accepted) {
        const restored = await updateCode([...new Set([...preserved, ...(appliedCode ? [appliedCode] : [])])].join(','));
        renderPromo(restored);
        throw new Error(text.ineligible);
      }
      appliedCode = normalized; storage.set('kalie_applied_code', normalized);
      if (normalized) fetch(root + 'discount/' + encodeURIComponent(normalized) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' }).catch(() => {});
      input.value = normalized;
      renderPromo(data);
      if (window.KALIE_CART?.refresh) await window.KALIE_CART.refresh();
      if (!normalized) status.textContent = text.removed;
    } catch (error) { status.textContent = error.message || text.promoError; }
    finally { promoBusy = false; button.disabled = false; $('[data-kalie-promo-remove]').disabled = false; form.removeAttribute('aria-busy'); }
  }
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-kalie-promo-form]')) return;
    event.preventDefault();
    const input = $('[data-kalie-promo-input]', event.target);
    if (!input.value.trim()) { $('[data-kalie-promo-status]').textContent = text.invalid; input.focus(); return; }
    applyCode(input.value);
  });
  document.addEventListener('click', event => { if (event.target.closest('[data-kalie-promo-remove]')) applyCode(''); });
  document.addEventListener('kalie:cart', event => renderPromo(event.detail.cart));

  function setupStory(scope = document) {
    scope.querySelectorAll('[data-kalie-video]').forEach(video => {
      if (video.dataset.bound) return;
      video.dataset.bound = 'true';
      const card = video.closest('.kalie-cro-video-card'), mute = $('[data-kalie-mute]', card), pause = $('[data-kalie-pause]', card);
      video.muted = true;
      if (reduce.matches) { video.autoplay = false; video.pause(); pause.textContent = '▶'; }
      function loadVideo() { if (video.dataset.loaded) return; video.dataset.loaded = 'true'; video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; }); video.load(); }
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { loadVideo(); if (!reduce.matches && !video.dataset.paused) video.play().catch(() => {}); }
        else video.pause();
      }), { threshold: .2 });
      observer.observe(video);
      mute.addEventListener('click', () => { video.muted = !video.muted; mute.setAttribute('aria-pressed', String(!video.muted)); mute.setAttribute('aria-label', video.muted ? text.unmute : text.mute); });
      pause.addEventListener('click', () => {
        loadVideo();
        if (video.paused) { video.dataset.paused = ''; video.play().catch(() => {}); }
        else { video.dataset.paused = 'true'; video.pause(); }
      });
      video.addEventListener('play', () => { pause.textContent = 'Ⅱ'; pause.setAttribute('aria-label', text.pause); });
      video.addEventListener('pause', () => { pause.textContent = '▶'; pause.setAttribute('aria-label', text.play); });
      video.addEventListener('error', () => { video.hidden = true; $('.kalie-cro-video-actions', card).hidden = true; });
    });
    scope.querySelectorAll('[data-kalie-carousel]').forEach(button => {
      if (button.dataset.bound) return; button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const track = document.getElementById(button.getAttribute('aria-controls'));
        if (!track) return;
        const step = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        track.scrollBy({ left: step * Number(button.dataset.kalieCarousel), behavior: reduce.matches ? 'instant' : 'smooth' });
      });
    });
  }
  const input = $('[data-kalie-promo-input]');
  if (input) input.value = appliedCode || storage.get('kalie_promo_code');
  document.querySelectorAll('[data-jp-product]').forEach(product => {
    const finish = $('[data-jp-finish-label]', product)?.textContent?.trim() || 'Acier Brossé';
    variantState(product, finish, !$('[data-jp-add]', product)?.disabled, $('[data-cure-pack]:checked', product)?.value);
  });
  delivery(); setupStory();
  setInterval(delivery, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) delivery(); });
  document.addEventListener('shopify:section:load', event => { setupStory(event.target); delivery(); });
})();
